import React from "react";
import { Truck, Layers, MapPin } from "lucide-react";

const MESSAGES = [
    { icon: Truck, text: "Free Express Shipping On Orders Over $250" },
    { icon: Layers, text: "Bundle Your Research Stack To Get Up To 30% Off" },
    { icon: MapPin, text: "Same Day Delivery For Sydney Metro Area" },
];

export default function AnnouncementBar() {
    return (
        <div
            data-testid="announcement-bar"
            className="anno-glass relative h-9 overflow-hidden"
        >
            <div className="relative max-w-7xl mx-auto h-full">
                {MESSAGES.map((m, i) => (
                    <div
                        key={i}
                        className="absolute inset-0 flex items-center justify-center gap-2 text-xs sm:text-sm font-medium text-pep-navy anno-slide"
                        style={{ animationDelay: `${i * 4}s` }}
                    >
                        <m.icon className="w-3.5 h-3.5 text-pep-primary" />
                        <span>{m.text}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}
